import Vue from 'vue'
import Vuelidate from 'vuelidate';

import './utils/promise'
import animations from  './utils/animations'
import TopMenu from './components/TopMenu'
import common from  './module/common'
import './utils/autoComplete/autoCompleteLoader'
import StockMessage from './components/StockMessage'
import CookieBar from './components/CookieBar'
import NewsletterPopup from './components/NewsletterPopup'
import ContactInfo from './components/dashboard/ContactInfo';
import '../../resources/assets/js/Cart/cart';
import '../../resources/assets/js/Dashboard/orders';

Vue.use(Vuelidate);

if (common.isMobile() || common.isTablet()) {
  animations.footerHeaderSlider();
}
common.addAdditionalMenuEventListeners();

let that;

let addHeaderAnimation = () => {
    let css = document.createElement("style");

    css.type = "text/css";
    css.innerHTML = `header{transition:transform 0.7s cubic-bezier(0.19, 1, 0.22, 1);}
    @media (min-width: 741px) and (max-width: 980px) { header.is-scrollingDown:not(.header-checkout){transform:translateY(-9rem)}}
    @media (min-width: 981px) { header.is-scrollingDown:not(.header-checkout){transform:translateY(-6rem)}}`;
    document.head.appendChild(css);
};

addHeaderAnimation();

const cart = new Vue({
    el: '#futurumClient',
    components: {TopMenu, StockMessage, CookieBar, NewsletterPopup, ContactInfo },
    data: {
        domain: window.env.baseUrl,
        inputValue: '',
        menuContent:{},
        showMainNav: false,
        showNewsLetterPopup: false,
        seoShowMore:false,
        // General
        seen: false,
        showAccount: false,
        focused: false,
        stockMessage: '',
        gdprCookieExists: false
    },
    methods:{
        setGdprCookie(){
            common.setGdprCookie();
        },
        searching: function (event) {
            event.preventDefault();
            let searchValue = $('.search input').val();

            window.location.href = `${window.env.baseUrl}/search?q=${searchValue}`;
        },
        getMenuContent() {
            return common.getMenuContent(that);
        },
        getStockMessage () {
            return common.getStockMessage(that);
        },
        // Add/remove from wishlist
        wishlistToggle: function (event) {
            var heart = event.currentTarget;
            this.toggleClass(heart, 'is-active');

            if (hasClass(heart, 'is-active')) {
                heart.setAttribute('title', 'Remove from wish list');
            }
            else {
                heart.setAttribute('title', 'Add to wish list');
            }
        },
        closeMainNav () {
            common.closeMainNav(this);
        },
        dropDownProfileClick () {
            common.dropDownProfileClick(this);
        },
        dropDownAccount () {
          common.dropDownAccount(this);
          this.closeMainNav();
        },
        toggleElement: function (event) {
            this.toggleClass(event.currentTarget, 'is-active');
        },

        toggleParent: function (event) {
            this.toggleClass(event.currentTarget.parentNode, 'is-active');
        },

        toggleClass: function(element, className) {
            if (! $(element).length) {
                return false;
            }
            if (element.classList) {
                element.classList.toggle(className);
            } else {
                let classes = element.className.split(' ');
                let existingIndex = classes.indexOf(className);

                if (existingIndex >= 0)
                    classes.splice(existingIndex, 1);
                else
                    classes.push(className);

                element.className = classes.join(' ');
            }
        },
        autoCloseProfile () {
            $(this.$el).on("click", (event) => {
                if (!$(event.target).parents("#accountMenu").length && !$(event.target).parents(".account").length) {
                    cart.$data.showAccount = false;
                }
            })
        },
        toggleSpecialProductVariations(event) {
            common.toggleSpecialProductVariations(event);
        }
    },
    mounted(){
        common.onSendEmailAnchor();
        common.onServiceFaqAnchor();
        if ($('.size-tables-body-block').length) {
          common.sizeTableEventListener();
        }
    },
    created:function() {
        that = this;

        common.getUserInfo(that);
        common.initScroll(that);
        common.setCartInfo();

        if(common.isNeededSpecialMenuBehavior()){
            $("header .bottomBar .containerFluid .mainNavigation .mainNavBar .background").css({"width":0, "height":0});
            $('.subNavigation-home').css("display", "none");

            $("#overlayContainer .overlay.overlay-MainNav").css("display", "none");
        }

        this.getMenuContent();
        this.getStockMessage();

        common.gdprCookieInit(this);
        common.fitIEImages();
    }
});

